import React from 'react';
import './App.css';
import ProfilePic from './ProfilePic.jpg';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function Projects()
{
    return (
        <div className='projectspage'>
            <Helmet>
                <title>Projects | Nour H.</title>
            </Helmet>
            <div className='header'>
                <div className='leftHeader'>
                    <img src={ProfilePic} alt='Profile' className='profileicon'></img>
                    <p className='nameHeader'>Nour H.</p></div>
                <div className='buttons'>
                    <Link to='/'>
                        <button className='aboutButtonHeader'>About</button>
                    </Link>
                    <Link to='/Projects'>
                        <button className='projectsButtonHeader'>Projects</button>
                    </Link>
                    <Link to='/Contact'>
                        <button className='contactButtonHeader'>Contact</button>
                    </Link>
                </div>
            </div>
            <div className='projectspost'>
                <h1 className='title'>Title</h1>
                <p className='date'>Date</p>
                <p className='projectstext'>Text..</p>
            </div>
        </div>
    );
}

export default Projects;